import styled from 'styled-components'

import { Color } from 'root-constants'

export const StyledAyahGender = {
  Container: styled.div`
    max-width: 375px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    padding: 16px 24px 0;
    margin: 0 auto;
  `,
  Header: styled.header`
    width: 100%;
    margin-bottom: 16px;
  `,
  Title: styled.h1`
    font-size: 32px;
    font-weight: 700;
    line-height: 36px;
    text-align: center;
    color: ${Color.INK_DARKEST};

    margin: 0 auto 8px;

    & strong {
      color: ${Color.BLUE_DARKER};
    }
  `,
  Subtitle: styled.p`
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    text-align: center;
    text-transform: none;
    color: ${Color.INK_DARKEST};

    margin: 0 auto;
  `,
  CardsContainer: styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;

    margin-bottom: 24px;
  `,
  Terms: styled.div`
    width: 100%;
    margin-top: auto;
  `,
  TermsNote: styled.p`
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    text-align: center;
    color: ${Color.INK_LIGHT};

    padding: 20px 0 24px;
    margin: 0;
  `,
}
